import { useState, useEffect, useContext } from "react";
import { Link } from "wouter";
import "./PageHeader.scss";
import userProfile from '../../../assets/userprofile.svg'
import iconArrow from '../../../assets/arrow-down.svg'
import iconSearch from '../../../assets/search.svg'
import logoGeniux from '../../../assets/logo.svg'
import logoGeniuxMovil from '../../../assets/logo-movil.svg'
import toggle from '../../../assets/toggle.svg'
import iconBell from '../../../assets/bell.svg'
import iconWallet from '../../../assets/wallet.svg'
import MenuVertical from "../MenuVertical/MenuVertical";
import MenuContext from "../../../context/MenuContext";
import { useModal } from "../../../customHooks/useModal";
import TooltipUser from "../../Molecules/Tooltip/TooltipUser";
import TooltipNotification from "../../Molecules/Tooltip/TooltipNotification";
import TooltipSearch from "../../Molecules/Tooltip/TooltipSearch";

const PageHeader = () => {
  const [showMenuMovil, setShowMenuMovil] = useState(false)
  const { setIsMenuOpen } = useContext(MenuContext)
  const [tooltipUserVisible, openTooltipUser, closeTooltipUser] = useModal()
  const [tooltipNotificationVisible, openTooltipNotification, closeTooltipNotification] = useModal()
  const [tooltipSearchVisible, openTooltipSearch, closeTooltipSearch] = useModal()

  useEffect(() => {
    const handleResize = () => {
      setShowMenuMovil(false)
      closeTooltipUser()
      closeTooltipNotification()
    }
    window.addEventListener('resize', () => handleResize())
    return () => {
      window.removeEventListener('resize', () => handleResize())
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Click al logo
  const handleClickLogo = () => {
    setShowMenuMovil(false)
    setIsMenuOpen(false)
  }

  // Tooltip user
  const handleTooltipUser = () => {
    if(tooltipUserVisible) {
      closeTooltipUser()
    } else {
      openTooltipUser()
      closeTooltipNotification()
      closeTooltipSearch()
    }
  }

  // Tooltip Notification
  const handleTooltipNotification = () => {
    if(tooltipNotificationVisible) {
      closeTooltipNotification()
    } else {
      openTooltipNotification()
      closeTooltipUser()
      closeTooltipSearch()
    }
  }

  // Tooltip search
  const handleTooltipSearch = () => {
    if(tooltipSearchVisible) {
      closeTooltipSearch()
    } else {
      openTooltipSearch()
      closeTooltipUser()
      closeTooltipNotification()
    }
  }

  return (
    <>
    <header className="page-header">
      <div className="page-header__container">
        <div className="m-hidden s-main-center s-cross-center">
          <div className="page-header__toggle" onClick={() => setShowMenuMovil(!showMenuMovil)}><img src={toggle} alt="toggle menu" /></div>
          <h1 className="page-header__title ml-20" onClick={() => handleClickLogo()}> <Link href="/dashboard"><img src={logoGeniuxMovil} alt="Logo Geniux" /></Link></h1>
        </div>

        <h1 className="page-header__title s-hidden m-show" onClick={() => handleClickLogo()}> <Link href="/dashboard"><img src={logoGeniux} alt="Logo Geniux" /></Link></h1>

        <div className="page-header__data s-main-justify s-cross-center ">
          <div className="page-header__icons s-hidden m-show">
            <div className="main-wallet container-icon ">
              <p className="source-16 sm-bold c-white">USD $50</p>
              <img alt="Icono de wallet" src={iconWallet}  className="pl-15 page-header__icon "/>
            </div>

            {/* <div className="container-icon search">
              <div class="container">
                <div class="search-box">
                  <input type="text" />
                  <span></span>
                </div>
              </div>
            </div> */}
            
            <div>
              <div className="container-icon" onClick={() => handleTooltipSearch()}>
                <img alt="icono de Buscar" src={iconSearch} className="page-header__icon" />
              </div>
              <TooltipSearch isVisible={tooltipSearchVisible} closeTooltipSearch={closeTooltipSearch} />
            </div>

            <div className="container-icon notification" onClick={() => handleTooltipNotification()}>
              <div>
                <img alt="Icono de Notifiación" src={iconBell} className="page-header__icon bell" />
              </div>
            </div>
            <TooltipNotification isVisible={tooltipNotificationVisible} closeTooltipNotification={closeTooltipNotification} />
          </div>
          <div className="page-header__copy ml-30 page-header-data-user c-white">
            <p>Super Admin (Rol)</p>
            <p>María alejandra Texeira</p>
          </div>
          <div className="page-header__profilePicture s-cross-center ml-20" onClick={() => handleTooltipUser()}>
            <img alt="user profile" src={userProfile} />
            <img alt="iconArrow" src={iconArrow} className="ml-10 icon-open-drawer"  />
          </div>
          <TooltipUser isVisible={tooltipUserVisible} closeTooltipUser={closeTooltipUser} />
        </div>
      </div>
    </header>
    
    <div className={`s-menu ${showMenuMovil && 'show'}`}>
      <MenuVertical heightIcon="1.5em" setShowMenuMovil={setShowMenuMovil} />
    </div>
    </>
  );
};

export default PageHeader;
